const {track,clamp}=require('./scroll-driver.js');
document.querySelectorAll('[data-project-paths]').forEach(element=>{
 const panels=[...element.querySelectorAll('[data-path-panel]')],links=[...element.querySelectorAll('[data-path-select]')];
 track(element,rects=>{
  const index=Math.max(0,rects.findLastIndex(rect=>rect.top<innerHeight*.52));
  links.forEach((link,i)=>{if(i===index)link.setAttribute('aria-current','step');else link.removeAttribute('aria-current');});
  panels.forEach((panel,i)=>{panel.classList.toggle('is-current',i===index);panel.style.setProperty('--path-fill',String(clamp((innerHeight*.75-rects[i].top)/(rects[i].height+innerHeight*.25))));});
 },()=>panels.map(panel=>panel.getBoundingClientRect()));
});
const requested=new URLSearchParams(location.search).get('leistung');
const services={webdesign:'Webdesign',contao:'Contao-Webentwicklung',email:'E-Mail, Domain & Hosting',wartung:'Wartung & Support',foto:'Fotografie & Drohnenaufnahmen'};
const serviceField=document.querySelector('.one-contact select[name="service"]');
if(serviceField&&!serviceField.value&&services[requested])serviceField.value=services[requested];
